import React from 'react';

export const IconStrategy: React.FC<React.SVGAttributes<SVGElement>> = () => (
  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <circle fill="#00A2D9" cx="50" cy="50" r="50" />
      <path
        d="M69.3 57.3l1 1c.5.5.5 1.3 0 1.8l-3.5 3.5v.5l3.5 3.5c.5.5.5 1.3 0 1.8l-1 1c-.5.5-1.3.5-1.8 0L64 66.9a.3.3 0 00-.5 0L60 70.4c-.5.5-1.3.5-1.8 0l-1-1c-.5-.5-.5-1.3 0-1.8l3.5-3.5c.2-.1.2-.3 0-.5l-3.5-3.5c-.5-.5-.5-1.3 0-1.8l1-1c.5-.5 1.3-.5 1.8 0l3.5 3.5c.2.2.4.2.5 0l3.5-3.5c.5-.5 1.3-.5 1.8 0z"
        fill="#FFF"
        fillRule="nonzero"
      />
      <path
        d="M77.7 34.9l-6.2-10.6c-.5-.9-1.8-.9-2.3 0L63 34.9c-.6.8 0 2 1 2h4c.2 0 .4 0 .4.3v2.3a8 8 0 01-8 7.9H40.8c-6.6 0-11.9 5.3-11.9 11.8v1.3c0 .2 0 .3-.2.4a8.6 8.6 0 104.4 0 .3.3 0 01-.2-.4v-1.3a8 8 0 017.9-7.9h19.8c6.5 0 11.8-5.3 11.8-11.8v-2.3c0-.2.2-.4.4-.4h3.9c1 0 1.7-1 1.1-2zM35.4 69a4.6 4.6 0 11-9.2 0 4.6 4.6 0 019.2 0zM43 28.3l1 1c.4.5.4 1.3 0 1.8l-3.6 3.5v.5l3.5 3.5c.5.5.5 1.3 0 1.9l-1 .9c-.4.5-1.3.5-1.8 0l-3.5-3.5a.3.3 0 00-.4 0l-3.5 3.5c-.5.5-1.4.5-1.9 0l-1-1c-.4-.5-.4-1.3 0-1.8l3.6-3.5v-.5l-3.5-3.5c-.5-.5-.5-1.3 0-1.8l1-1c.4-.5 1.3-.5 1.8 0l3.5 3.5c.1.2.3.2.4 0l3.5-3.5c.5-.5 1.4-.5 1.9 0z"
        fill="#FFF"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
